import { Icon } from "./Component";


const StatCard = ({ label, name, units, icon, color, bg }) => {
 return (
  <div
   style={{
    border: "1px solid #e5e9f2",
    borderRadius: "8px",
    padding: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "#fff",
    height: "100%",
   }}
  >
   <div>
    <div
     style={{
      fontSize: "13px",
      color: "#8094ae",
      marginBottom: "4px",
     }}
    >
     {label}
    </div>

    <div
     style={{
      fontSize: "16px",
      fontWeight: "600",
      color: "#364a63",
     }}
    >
     {name || "-"}
    </div>

    {units && (
     <div
      style={{
       fontSize: "12px",
       color: "#8094ae",
       marginTop: "2px",
      }}
     >
      {units}
     </div>
    )}
   </div>

   <div
    style={{
     width: "38px",
     height: "38px",
     borderRadius: "50%",
     backgroundColor: bg,
     display: "flex",
     alignItems: "center",
     justifyContent: "center",
    }}
   >
    <Icon name={icon} style={{ color: color, fontSize: "18px" }} />
   </div>
  </div>
 );
};

export default StatCard;